import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import TabNav from '../../../composants/TabNav/TabNav';
import Banner from '../../../composants/Banner/Banner';
import SectionPliable from '../../../composants/SectionPliable/SectionPliable';
import TabAvisDocuments, { AccordCadreInfo } from '../components/DetailCandidature/TabAvisDocuments';
import FilQuestionsReponses from '../components/DetailCandidature/FilQuestionsReponses';
import { TITRE_QUESTIONS_REPONSES } from '../components/DetailCandidature/TabQuestionsReponses';
import './InformationsAC.css';

const ONGLETS = ['Avis et documents', TITRE_QUESTIONS_REPONSES];

/** Page publique de consultation d'un accord-cadre. Accessible sans connexion. */
const InformationsAC: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const [accordCadre, setAccordCadre] = useState<AccordCadreInfo | null>(null);
  const [loading, setLoading] = useState(true);
  const [introuvable, setIntrouvable] = useState(false);
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    // Le composant survit a un changement d'id (meme route) : sans remise a zero,
    // un 404 precedent resterait affiche par-dessus une consultation valide.
    let annule = false;
    setLoading(true);
    setIntrouvable(false);

    fetch(`${process.env.REACT_APP_API_URL}/publications/ac27/accords-cadres/${id}`)
      .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
      .then((json) => { if (!annule) setAccordCadre(json?.data ?? null); })
      .catch(() => { if (!annule) setIntrouvable(true); })
      .finally(() => { if (!annule) setLoading(false); });

    return () => { annule = true; };
  }, [id]);

  if (loading) {
    return (
      <div className="informations-ac">
        <div className="informations-ac__chargement">
          <div className="spinner" />
          <span>Chargement de la consultation...</span>
        </div>
      </div>
    );
  }

  if (introuvable || !accordCadre) {
    return (
      <div className="informations-ac">
        <Banner variant="info" message="Cette consultation n'est pas disponible." />
        <button className="informations-ac__retour" onClick={() => navigate('/publications')}>
          ← Retour aux publications
        </button>
      </div>
    );
  }

  return (
    <div className="informations-ac">
      <div className="informations-ac__entete">
        <button className="informations-ac__retour" onClick={() => navigate('/publications')}>
          ← Retour aux publications
        </button>
        <h1>{accordCadre.nom}</h1>
      </div>

      <TabNav tabs={ONGLETS} activeTab={activeTab} onTabChange={setActiveTab} />

      {activeTab === 0 ? (
        <TabAvisDocuments accordCadre={accordCadre} />
      ) : (
        <SectionPliable title={TITRE_QUESTIONS_REPONSES}>
          <Banner
            variant="info"
            message="Pendant la consultation, il est possible d'échanger dans cet onglet pour toutes difficultés techniques rencontrées avec la plateforme. Les messages seront lus par tous les candidats, ils doivent donc être anonymes et ne pas mentionner d'éléments qui permettraient de vous identifier (à l'exception de l'acheteur). Pour toute question qui n'implique pas un problème technique, nous vous invitons à utiliser l'outil de questions/réponses du profil acheteur AWS pour la consultation en cours."
          />
          <FilQuestionsReponses accordCadreId={accordCadre.id} lectureSeule />
        </SectionPliable>
      )}
    </div>
  );
};

export default InformationsAC;
